/**
 * "1." / "1…" / "2." … — PlayChess's own `getChessMoveNumber` (index.js
 * L672-684), ported verbatim onto this V2 home. Pure, no store reads, so the
 * hint-text builder (`hintText.ts`) and this file are both unit-testable
 * without a renderer.
 *
 * `isBlackTurnFirst` (the shared core's own field, `game.isBlackTurnFirst`)
 * is kept rather than dropped: Play & Learn's library positions (option '2')
 * can start with Black to move, exactly like any other custom-FEN game.
 */
export const getChessMoveNumber = (
  moveIndex: number,
  isBlackTurnFirst: boolean,
): string => {
  const moveNumber = isBlackTurnFirst
    ? Math.ceil((moveIndex - 1) / 2) + 1
    : Math.floor((moveIndex - 1) / 2) + 1;
  const dots = isBlackTurnFirst
    ? (moveIndex - 1) % 2 === 0
      ? '...'
      : '.'
    : (moveIndex - 1) % 2 === 0
    ? '.'
    : '...';
  return `${moveNumber}${dots}`;
};

export default getChessMoveNumber;
